<div
  class="tw:bg-white tw:rounded-t tw:justify-between tw:relative tw:items-center tw:flex tw:px-8 tw:py-2 tw:flex-wrap tw:gap-y-2 tw:min-h-12"
>
  <!-- Left side: Custom content slot for filters, chips, etc -->
  <div class="tw:flex tw:items-center tw:mr-8">
    <ng-content select="[slot=custom-controls]" />
  </div>

  <!-- Right side: Search and action buttons -->
  <div class="tw:flex tw:items-center">
    @if (showSearch()) {
      <div class="tw:self-center tw:mr-8 tw:mb-0">
        <div class="ga-input tw:w-full">
          <ga-icon [icon]="icons.Search" />
          <input
            id="employees-list-search"
            type="search"
            aria-label="searchBlock"
            placeholder="Search"
            (input)="changedSearchInput.emit($any($event.target).value)"
            i18n-placeholder
          />
        </div>
      </div>
    }

    <button
      class="ga-button ga-button--ghost ga-button--icon-only"
      type="button"
      title="Autosize all columns"
      (click)="autosizeColumns.emit()"
      i18n-title
    >
      <span class="vismaicon vismaicon-change-width tw:w-6 tw:h-6 tw:before:w-6 tw:before:h-6"></span>
    </button>
    <button
      class="ga-button ga-button--ghost ga-button--icon-only"
      type="button"
      title="Download Excel file"
      (click)="getExcel.emit()"
      i18n-title
    >
      <span class="vismaicon vismaicon-excel tw:w-6 tw:h-6 tw:before:w-6 tw:before:h-6"></span>
    </button>
    <button
      class="ga-button ga-button--ghost ga-button--icon-only"
      type="button"
      title="Download CSV file"
      (click)="getCsv.emit()"
      i18n-title
    >
      <span class="vismaicon vismaicon-csv tw:w-6 tw:h-6 tw:before:w-6 tw:before:h-6"></span>
    </button>
    <button
      class="ga-button ga-button--ghost ga-button--icon-only tw:mr-8"
      id="settings-btn"
      type="button"
      title="Grid settings"
      (click)="isDropdownOpen = !isDropdownOpen"
      i18n-title
    >
      <span class="vismaicon vismaicon-multiselection tw:w-6 tw:h-6 tw:before:w-6 tw:before:h-6 tw:rotate-90"></span>
    </button>
    <ng-content select="[slot=custom-buttons]" />
  </div>

  <div class="dropdown tw:absolute tw:w-[250px] tw:top-12 tw:right-0 tw:z-5" [ngClass]="{ open: isDropdownOpen }">
    <ul class="dropdown-menu" role="menu" aria-expanded="false" aria-hidden="true" aria-labelledby="dropdownButton1">
      <li><a (click)="resetColumns.emit()" i18n>Reset columns</a></li>
      <li><a (click)="clearFilters.emit()" i18n>Clear filters</a></li>
      @if (isFloatingFilterVisible) {
        <li><a (click)="onFilterButtonClick()" i18n>Hide floating filter</a></li>
      } @else {
        <li><a (click)="onFilterButtonClick()" i18n>Show floating filter</a></li>
      }
      @if (isAdvancedViewEnabled()) {
        @if (isAdvancedViewVisible()) {
          <li><a (click)="toggleAdvancedView.emit(false)" i18n>Hide advanced view</a></li>
        } @else {
          <li><a (click)="toggleAdvancedView.emit(true)" i18n>Show advanced view</a></li>
        }
      }
    </ul>
  </div>
</div>
